import { Select } from "antd"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const { Option } = Select
// ----------------------------------------------------------------------------

function _AppSelect(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { className, value, options, placeholder, onChange } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function renderOptions() {
    return options?.map(({ value, label }) => (
      <Option key={value} value={value}>
        {label}
      </Option>
    ))
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <Select
      value={value}
      onChange={onChange}
      className={`${className} my-select`}
      placeholder={placeholder}
    >
      {renderOptions()}
    </Select>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_AppSelect.propTypes = {
  className: PropTypes.string.isRequired,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
}

_AppSelect.defaultProps = {}

// ----------------------------------------------------------------------------

const AppSelect = styled(_AppSelect)`
  & {
    background: #ffffff;
    border-radius: 6px;
    height: 48px;
    text-align: right;
    .ant-select-selector {
      box-shadow: none !important;
      border: none !important;
      outline: none;
      height: 48px !important;
    }
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      line-height: 48px;
      font-size: ${(props) => props.theme.font.text.size};
      color: ${(props) => props.theme.colors.dark900};
      font-weight: 600;
      text-decoration: underline;
      padding-right: 0;
    }
    .ant-select-arrow {
      display: none;
    }
  }
`
// ----------------------------------------------------------------------------

export default AppSelect
